module.exports = __webpack_public_path__ + "img/state-success.a90088d3.png";